import { useEffect } from "react";

import { useIsSSR } from "../store/check-ssr/check-ssr.selectors";
import { useActiveLanguages } from "../store/languages/language.selectors";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useActiveLangs = () => {
  const { languages } = useActiveLanguages();
  const isSSR = useIsSSR();

  const { getLanguages } = useDispatchedActions();

  useEffect(() => {
    if (!languages.length && !isSSR) {
      getLanguages();
    }
  }, [languages.length, isSSR]);
};
